import { Navigate, useLocation } from "react-router-dom";

/**
 * Sends an old People URL to its new home, keeping the query string, hash and navigation state so a bookmarked
 * filter (`?tier=at-risk`), a `?ui=` preview or a `?from=` return list survives the move.
 */
export function LegacyPathRedirect({ to }: { to: string }) {
  const { search, hash, state } = useLocation();
  // `state` carries a list return's restoreScrollFrom / restoreSelectionFrom / removedPersonId.
  return <Navigate to={{ pathname: to, search, hash }} state={state} replace />;
}
